import { mappedArray } from '@10000/common'
import { Box } from '..'
import { Slice } from '.'
import { valueColors } from '../../../lookups'

export const MeterPie = () => (
  <Box position="absolute" inset>
    <svg width="100%" height="100%" viewBox="0 0 200 100" style={{ pointerEvents: 'none' }}>
      {mappedArray(6, i =>
        <Slice
          key={i}
          x={100}
          y={100}
          innerRadius={18}
          outerRadius={100}
          startAngle={-90 + (i * 30)}
          sweepAngle={30}
          fill={valueColors[i]}
        />
      )}
    </svg>
  </Box>
)